import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { getSubtypeHeader } from '../../../utils/subTypeHeader';

export default function ServiceForm({ shopType, formState, setFormState}) {
  const subtype = shopType;
  const headerText = getSubtypeHeader(subtype);

  return (
    <div className="form-section">
      <h3 className="section-title">{headerText}</h3>

      <div className="field">
        <label>Service Title / Specialty</label>
        <InputText
          value={formState[`serviceSpecialty_${subtype}`] || ''}
          onChange={(e) => setFormState(`serviceSpecialty_${subtype}`, e.target.value)}
          placeholder="e.g. House Cleaning, Laptop Repair, Haircut"
        />
      </div>

      <div className="field">
        <label>Service Area</label>
        <InputText
          value={formState[`serviceArea_${subtype}`] || ''}
          onChange={(e) => setFormState(`serviceArea_${subtype}`, e.target.value)}
          placeholder="e.g. Makati, Quezon City, Online only"
        />
      </div>

      {/* Common Checkboxes */}
      <div className="field">
        <div className="flex align-items-center">
          <Checkbox
            inputId={`homeService_${subtype}`}
            checked={formState[`homeService_${subtype}`] || false}
            onChange={(e) => setFormState(`homeService_${subtype}`, e.checked)}
          />
          <label htmlFor={`homeService_${subtype}`} className="ml-2">Offers Home Service</label>
        </div>
      </div>

      <div className="field">
        <div className="flex align-items-center">
          <Checkbox
            inputId={`byAppointment_${subtype}`}
            checked={formState[`byAppointment_${subtype}`] || false}
            onChange={(e) => setFormState(`byAppointment_${subtype}`, e.checked)}
          />
          <label htmlFor={`byAppointment_${subtype}`} className="ml-2">By Appointment Only</label>
        </div>
      </div>

      {/* Subtype-specific fields */}
      {subtype === 'SV_cleaning' && (
        <>
          <div className="field">
            <label>Cleaning Services Offered</label>
            <InputText
              value={formState[`cleaningServices_${subtype}`] || ''}
              onChange={(e) => setFormState(`cleaningServices_${subtype}`, e.target.value)}
              placeholder="e.g. Deep clean, Move-in/out, Carpet shampoo"
            />
          </div>

          <div className="field">
            <label>Supplies Provided</label>
            <InputText
              value={formState[`cleaningSupplies_${subtype}`] || ''}
              onChange={(e) => setFormState(`cleaningSupplies_${subtype}`, e.target.value)}
              placeholder="e.g. All supplies included, BYO vacuum"
            />
          </div>
        </>
      )}

      {subtype === 'SV_repairs' && (
        <>
          <div className="field">
            <label>Repair Type</label>
            <InputText
              value={formState[`repairType_${subtype}`] || ''}
              onChange={(e) => setFormState(`repairType_${subtype}`, e.target.value)}
              placeholder="e.g. Electronics, Appliances, Mobile"
            />
          </div>

          <div className="field">
            <label>Warranty Info</label>
            <InputText
              value={formState[`repairWarranty_${subtype}`] || ''}
              onChange={(e) => setFormState(`repairWarranty_${subtype}`, e.target.value)}
              placeholder="e.g. 30-day service warranty"
            />
          </div>
        </>
      )}

      {subtype === 'SV_beauty' && (
        <>
          <div className="field">
            <label>Beauty Services Offered</label>
            <InputText
              value={formState[`beautyServices_${subtype}`] || ''}
              onChange={(e) => setFormState(`beautyServices_${subtype}`, e.target.value)}
              placeholder="e.g. Haircut, Massage, Nails"
            />
          </div>

          <div className="field">
            <label>Target Clients</label>
            <div className="flex gap-3 flex-wrap">
              {['Men', 'Women', 'All'].map((option) => (
                <div key={option} className="flex align-items-center">
                  <Checkbox
                    inputId={`${option}_${subtype}`}
                    value={option}
                    onChange={(e) => {
                      const selected = formState[`targetClients_${subtype}`] || [];
                      const updated = selected.includes(e.value)
                        ? selected.filter(item => item !== e.value)
                        : [...selected, e.value];
                      setFormState(`targetClients_${subtype}`, updated);
                    }}
                    checked={(formState[`targetClients_${subtype}`] || []).includes(option)}
                  />
                  <label htmlFor={`${option}_${subtype}`} className="ml-2">{option}</label>
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {subtype === 'SV_freelance' && (
        <>
          <div className="field">
            <label>Service Focus</label>
            <InputText
              value={formState[`freelanceFocus_${subtype}`] || ''}
              onChange={(e) => setFormState(`freelanceFocus_${subtype}`, e.target.value)}
              placeholder="e.g. Graphic Design, Writing, Virtual Assistant"
            />
          </div>

          <div className="field">
            <label>Portfolio Link</label>
            <InputText
              value={formState[`portfolioLink_${subtype}`] || ''}
              onChange={(e) => setFormState(`portfolioLink_${subtype}`, e.target.value)}
              placeholder="https://yourportfolio.com"
            />
          </div>
        </>
      )}

      {subtype === 'SV_printing' && (
        <>
          <div className="field">
            <label>Printing Capabilities</label>
            <InputText
              value={formState[`printingTypes_${subtype}`] || ''}
              onChange={(e) => setFormState(`printingTypes_${subtype}`, e.target.value)}
              placeholder="e.g. Large format, Tarpaulin, Photocopy"
            />
          </div>

          <div className="field">
            <label>Design Services Included?</label>
            <InputText
              value={formState[`printDesignSupport_${subtype}`] || ''}
              onChange={(e) => setFormState(`printDesignSupport_${subtype}`, e.target.value)}
              placeholder="e.g. Yes, simple layout only"
            />
          </div>
        </>
      )}

      {subtype === 'SV_events' && (
        <>
          <div className="field">
            <label>Event Type Specialization</label>
            <InputText
              value={formState[`eventType_${subtype}`] || ''}
              onChange={(e) => setFormState(`eventType_${subtype}`, e.target.value)}
              placeholder="e.g. Weddings, Corporate, Birthdays"
            />
          </div>

          <div className="field">
            <label>Photography/Video Services?</label>
            <InputText
              value={formState[`hasMediaCoverage_${subtype}`] || ''}
              onChange={(e) => setFormState(`hasMediaCoverage_${subtype}`, e.target.value)}
              placeholder="e.g. Yes, with drone option"
            />
          </div>
        </>
      )}
    </div>
  );
}